import { render, staticRenderFns } from "./updateBigScreen.vue?vue&type=template&id=5457fb99&scoped=true&"
import script from "./updateBigScreen.vue?vue&type=script&lang=js&"
export * from "./updateBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./updateBigScreen.vue?vue&type=style&index=0&id=5457fb99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457fb99",
  null
  
)

export default component.exports